import { Group, Vector2, Vector3 } from 'three/webgpu'
import { easing } from 'maath'

export default class PointerTilt extends Group {
	static defaults = {
		amount: { x: 0.2, y: 0.4 },
		smoothing: 0.2,
		float: { bob: 0.02, sway: 0.025, speed: 0.6 },
		rotation: { x: 0, y: 0, z: 0 },
	}

	constructor(options = {}) {
		super()

		this.options = { ...PointerTilt.defaults, ...options }
		this.base = new Vector3(this.options.rotation.x, this.options.rotation.y, this.options.rotation.z)
		this.pointer = new Vector2()
		this.lean = new Vector2()

		this._onPointerMove = event => {
			this.pointer.set((event.clientX / window.innerWidth) * 2 - 1, -((event.clientY / window.innerHeight) * 2 - 1))
		}

		window.addEventListener('pointermove', this._onPointerMove)
	}

	update(delta, elapsed) {
		const { amount, smoothing, float } = this.options
		const cycle = elapsed * float.speed

		easing.damp(this.lean, 'x', this.pointer.x * amount.y, smoothing, delta)
		easing.damp(this.lean, 'y', this.pointer.y * amount.x, smoothing, delta)

		this.position.y = Math.sin(cycle) * float.bob
		this.rotation.set(
			this.base.x - this.lean.y + Math.sin(cycle * 0.7) * float.sway,
			this.base.y + this.lean.x + Math.sin(cycle * 0.45) * float.sway,
			this.base.z + Math.cos(cycle * 0.55) * float.sway
		)
	}

	dispose() {
		window.removeEventListener('pointermove', this._onPointerMove)
	}
}
